const METADATA_FIELDS = new Set(['index', 'key', 'maxLength', 'state', 'description']);

const findImportLengthErrors = (csvRows) => (csvRows || []).flatMap((row) => {
  const maxLength = row.maxLength === undefined || row.maxLength === null || row.maxLength === ''
    ? NaN
    : Number(row.maxLength);
  if (!Number.isFinite(maxLength)) return [];

  return Object.keys(row).flatMap((field) => {
    if (METADATA_FIELDS.has(field)) return [];
    const value = row[field];
    if (value === undefined || value === null || value === '') return [];
    const { length } = String(value);
    if (length <= maxLength) return [];
    return [{
      index: row.index,
      key: row.key,
      language: field,
      length,
      maxLength,
    }];
  });
});

export default findImportLengthErrors;
